export const api = import.meta.env.DEV
  ? "https://in.portal.americau.com/woogi/0.1/actor/cgi.php"
  : "/woogi/0.1/actor/cgi.php";
